module.exports = __webpack_public_path__ + "static/media/img-card (6).362b882f.jpg";